import { render } from "./OverdueContent.vue?vue&type=template&id=68133a02&scoped=true&ts=true"
import script from "./OverdueContent.vue?vue&type=script&lang=ts"
export * from "./OverdueContent.vue?vue&type=script&lang=ts"

import "./OverdueContent.vue?vue&type=style&index=0&id=68133a02&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68133a02"]])

export default __exports__